import reusables from '@styles/theme/reusables';
import theme from '@styles/theme';
export default {
  checkboxContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    p: '4px 0 0 4px'
  },
  checkbox: (isDropdown: boolean, index: number) => ({
    mt: isDropdown && index === 0 ? 0 : '16px',
    mb: isDropdown ? 0 : '10px',
    display: 'flex',
    flex: 1,
    label: {
      transform: 'translateY(-2px)',
      cursor: 'pointer',
      display: 'inline-flex'
    },
    '&:last-child': {
      mb: 0
    }
  }),
  count: {
    width: '20px',
    textAlign: 'center',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    mb: '8px',
    color: theme.rawColors.darkGrey500
  },
  list: (useScroll = false) => ({
    position: 'relative',
    listStyleType: 'none',
    height: useScroll ? 307 : 'auto',
    maxHeight: useScroll ? 307 : 'auto',
    overflow: 'hidden',
    '.swiper': {
      position: 'relative',
      width: '100%',
      height: '100%'
    },
    '.swiper-scrollbar': {
      width: '2px',
      right: '2px'
    },
    '.swiper-slide': {
      width: '100%',
      height: 'auto'
    }
  }),
  filterList: {
    listStyleType: 'none',
    p: '4px 0 0 4px'
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'column'
  },
  radio: {
    mt: '16px',
    mb: '10px',
    display: 'flex',
    flex: 1,
    label: {
      width: '100%',
      cursor: 'pointer',
      display: 'inline-flex'
    }
  },
  radioContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  filterElement: (isDropdown: boolean) => {
    const size = isDropdown ? '24px' : '40px';
    return {
      height: size,
      display: 'inline-flex',
      width: 'calc(100% - 3px)',
      mb: isDropdown ? '14px' : '16px',
      '&:last-child': {
        mb: 0
      },
      span: {
        height: size,
        lineHeight: size,
        display: 'inline-block',
        textAlign: 'left',
        overflow: 'hidden'
      }
    };
  },
  imgWrapper: (isActive: boolean, isDropdown: boolean) => {
    const size = isDropdown ? '24px' : '40px';
    return {
      borderRadius: '50%',
      position: 'relative',
      border: `1px solid ${isActive ? theme.rawColors.accent700 : theme.rawColors.lightGrey300}`,
      overflow: 'hidden',
      mr: isDropdown ? '4px' : '16px',
      maxHeight: size,
      maxWidth: size
    };
  },
  imageFill: {
    objectFit: 'cover',
    verticalAlign: 'top',
    marginTop: '-2px'
  },
  buttonWrapper: {
    background: 'none',
    outline: 'none',
    border: 'none',
    display: 'inline-flex',
    userSelect: 'none',
    width: '100%',
    color: theme.rawColors.darkGrey700,
    ...reusables.mainTransition('color'),
    '&:hover': {
      color: theme.rawColors.accent700
    }
  },
  checkIcon: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: theme.zIndex.documentUp,
    svg: {
      position: 'relative',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }
  },
  imgPlaceholder: {
    display: 'inline-block',
    width: '42px',
    height: '42px',
    verticalAlign: 'top'
  }
};